import { reduxForm, formValueSelector } from 'redux-form/immutable'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import moment from 'moment'

import withDidMountRequest from 'app/connectors/withDidMountRequest'
import { updateSprintForOrganization, fetchSprintById } from 'store/entities/organizations/actions'
import { isPendingSprint } from 'store/entities/organizations/selectors'
import OrganizationSprintForm, { submitSprintFormHelper } from '../OrganizationSprintForm'
export const ORGANIZATION_SPRINT_FORM_EDIT = 'ORGANIZATION_SPRINT_FORM_EDIT'

const formProps = {
  form: ORGANIZATION_SPRINT_FORM_EDIT,
  initialValues: Map({
    dates: Map({
      startDate: moment(),
      endDate: moment(),
    }),
  }),
  onSubmit: (
    values,
    dispatch,
    {
      match: {
        params: { organizationId },
      },
    }
  ) => {
    const newValues = submitSprintFormHelper(values, organizationId)
    dispatch(updateSprintForOrganization({ data: newValues.toJS(), organizationId }))
  },
}

const mapStateToProps = state => {
  const formSelector = formValueSelector(ORGANIZATION_SPRINT_FORM_EDIT)
  return {
    isPendingSprint: isPendingSprint(state),
    startDate: formSelector(state, 'dates')?.get('startDate'),
  }
}

const mapDispatchToProps = {
  fetchSprintById,
}

const mergeProps = (stateProps, { fetchSprintById, ...dispatchProps }, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onRequest: () => {
      const {
        match: {
          params: { organizationId, sprintId },
        },
      } = ownProps
      fetchSprintById({ organizationId, sprintId })
    },
  }
}

export default reduxForm(formProps)(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(withDidMountRequest(OrganizationSprintForm))
)
